import { css } from "@linaria/core";

export const buttonCls = css`
  -webkit-appearance: none;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  outline: none;

  display: flex;
  align-items: center;
  cursor: pointer;

  color: #434343;
  transition: color 0.1s linear;

  &:hover,
  &:focus {
    color: var(--color-primary);
  }
`;

export const textCls = css`
  font-family: var(--font-family);
  font-size: calc(14 * var(--font-px));
  font-weight: 400;
  text-transform: uppercase;
`;

export const chevronWrapperCls = css`
  margin-left: 16px;
  width: 14px;
`;

export const listCls = css`
  margin: 0;
  list-style-type: none;

  width: 150px;
  padding: 15px 30px;
`;
